export default __webpack_public_path__ + "static/media/01.f6921c76.jpg";